import { ChangeDetectionStrategy, Component, inject, computed, input } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiListComponent, type ListItemModel } from '@big-direkt/ui/list';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { translateObjectSignal } from '@jsverse/transloco';
import { SearchResultTrackingDirective } from '../../directives/search-result-tracking.directive';
import { type SearchResult } from '../../models/search-result';
import { ResultItemComponent } from './result-item/result-item.component';

@Component({
    selector: 'big-search-result',
    templateUrl: './result.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
    imports: [ResultItemComponent, UiListComponent, UiLinkComponent, SearchResultTrackingDirective],
})
export class ResultComponent {
    private readonly environmentService = inject(EnvironmentService);

    public readonly servicePhoneNumber = this.environmentService.servicePhoneNumber;

    public readonly currentPage = input.required<number>();
    public readonly classList = input('block');
    public readonly result = input.required<SearchResult>();
    public readonly searchTerm = input.required<string>();

    public readonly translate = translateObjectSignal('search');

    public readonly emptyResultList = computed<ListItemModel[]>(() => {
        const { emptyResultList } = this.translate();

        return [
            {
                link: { href: '', title: '', target: '' },
                text: emptyResultList.check,
                title: '',
            },
            {
                link: { href: '', title: '', target: '' },
                text: emptyResultList.change,
                title: '',
            },
            {
                link: { href: '', title: '', target: '' },
                text: emptyResultList.reduce,
                title: '',
            },
            {
                link: { href: '', title: '', target: '' },
                text: emptyResultList.specialChairs,
                title: '',
            },
        ];
    });
}
